import { useRoles } from '@fourthwall/auth'
import type { AvailableRoles } from '@hooks/useAvailableRoles'
import { useAvailableRoles } from '@hooks/useAvailableRoles'

import type { SelectableRole } from '../Team.types'
import { getSelectableRoles } from '../utils/getSelectableRoles'

export const useTeamMembersRoles = (): {
  topRoleId: string | undefined
  selectableRoles: SelectableRole[]
  canUserManageTopRoleTeamMembers: boolean
  availableRoles: {
    roles?: AvailableRoles | undefined
    loading: boolean
    invalidate: () => void
  }
  getRoleName: (roleId: string) => string
} => {
  const { group: userRole, invalidateRolesQuery, isLoadingRoles } = useRoles()
  const { availableRoles, isLoading, invalidateAvailableRoles } = useAvailableRoles()

  const topRoleId = availableRoles && availableRoles[0].id

  const canUserManageTopRoleTeamMembers = userRole === topRoleId

  const selectableRoles =
    (availableRoles &&
      getSelectableRoles(
        canUserManageTopRoleTeamMembers ? availableRoles : availableRoles.slice(1),
      )) ||
    []

  const getRoleName = (roleId: string) =>
    (availableRoles && availableRoles.find(({ id }) => id === roleId)?.name) || roleId

  return {
    topRoleId,
    selectableRoles,
    canUserManageTopRoleTeamMembers,
    availableRoles: {
      roles: availableRoles,
      loading: isLoadingRoles || isLoading,
      invalidate: () => {
        invalidateAvailableRoles()
        invalidateRolesQuery()
      },
    },
    getRoleName,
  }
}
